export class Action {

	run() {
		this._request = new Promise((resolve) => {
			const wait = () => {
				if (window.CCM) {
					resolve((window.CCM.acceptedEmbeddings || []).map(({name}) => name));
				} else {
					setTimeout(wait, 1000);
				}
			};

			return wait();
		});

		this.context.values.add('cookiedisclaimer:request', {
			request: this._request
		});
	}

}
